module.exports = __webpack_public_path__ + "static/media/settingsActive.bea1e511.svg";